export const DISABLE_STREAM =
  process.env.REACT_APP_DISABLE_STREAM === 'true';

export const API_URL =
  process.env.REACT_APP_API_URL || "https://say52backend.arcware.cloud";

export const ARCWARE_SHARE_ID =
  process.env.REACT_APP_ARCWARE_SHARE_ID ||
  "share-9f4d9f9c-61c0-4316-9c87-24089ec5eb5d";

export const IS_DEVELOPMENT =
  process.env.NODE_ENV !== 'production';

export const IS_TEST_LEAD =
  process.env.REACT_APP_TEST_LEAD_MODE === "false" ||
  window.location?.host === "configurator.saycarbonyachts.com"
    ? false
    : (typeof process.env?.REACT_APP_TEST_LEAD_MODE !== "undefined" ? ['true', true].some(el => el === process.env?.REACT_APP_TEST_LEAD_MODE) : true);
